import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// M6: register the service worker for offline / cache-first behaviour.
// No-op in development; the helper unregisters any prior SW so dev hot
// reload isn't intercepted.
serviceWorkerRegistration.register();
